import { render, staticRenderFns } from "./OutcomesCollapsableProduct.vue?vue&type=template&id=358a4d92&"
import script from "./OutcomesCollapsableProduct.vue?vue&type=script&lang=js&"
export * from "./OutcomesCollapsableProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports